import type { FaireProductEntity } from "../../entity_types/product";

export const p_e7wau4yyxd: FaireProductEntity = {
  token: "p_e7wau4yyxd",
  type: "product",
  name: "Elderberry Syrup Wellness Elixir",
  brandToken: "b_5yoaobuy2a",
  brandName: "Naturacentric",
  imageUrl:
    "https://cdn.faire.com/fastly/53f111b39aabbeeddab9d244f7fa16cb645f8acf6ced346fa07f44c6bbfb19e6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e700abe87414309831990c9019fb9632d346afea31c6a8a6368f8b99b8ba481b.png",
    "https://cdn.faire.com/fastly/a6220866b6847210b87424f74c4b295556ed2980d3efb7df7e55d02198cf535d.png",
    "https://cdn.faire.com/fastly/ddf7d461bc9e1f8a77808d3d9b0b1341f4c205f5ad34459cbcc301ce7596300a.png",
    "https://cdn.faire.com/fastly/51ee65623a6aa8e78c25560f19bbe403cc78bf767fc10e7adf38e4df581be14c.png",
  ],
  priceDollars: 10.39,
  description:
    "Our botanical elixirs are concentrated herbal formulas to help naturally support the body. It is sweetened with local raw honey and can be added to carbonated water as an all-natural soda alternative or added to smoothies, popsicles, hot tea and more for the added boost of wellness.\n\nThis is not your average elderberry syrup!\n\nWellness Elixir This elixir was designed to be tougher than the average elderberry syrup. Jam packed with Anti-viral, Anti- bacterial, Antioxidant rich, immune and respiratory supportive herbs that nourish and strengthen your body. It can be used as a preventive and while under the weather. This is a must have in your herbal medicine cabinet.\n\nTASTE: Fruity balance of tart and sweet. Delicious, easy to drink. \nStandard dose is 1 teaspoon for children. 1 tablespoon for adults daily as a preventative. When starting to feel sick take 4 times daily. Can be added to Water, Juice, Tea and more.\n",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:54.354Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
